$(document).ready(function () {
    var ipCountry = $('html').data('ipcountry');

    var clientLocationArgs = redirectArgs.message[ipCountry];

    function init() {
        // to test / debug - force show the ip redirect
        let forceShow = false;
        if (new URL(window.location.href).searchParams.get("ip-redirect") === 'show') {
            forceShow = true;
            clientLocationArgs = {
                // flag_url: "https://objects.kaxmedia.com/auto/o/31121/b82a9f3ebf.png",
                leave_button_href: "/ie",
                leave_button_text: "Continue on Irish site",
                main_message: "To see the best offers available in your current location",
            };
        }

        if (!noRedirectBox() && (forceShow || shouldCreateRedirectBox())) {
            createRedirectBox(ipCountry);
        }
    }

    function shouldCreateRedirectBox() {
        if (
            typeof disableGeoRedirectMessage !== 'undefined' &&
            disableGeoRedirectMessage &&
            ipCountry === redirectArgs.site_code
        ) {
            return false;
        } else if (
            !getCookie('region_redirect_message') &&
            !disableGeoRedirectMessage &&
            typeof redirectArgs.message[ipCountry] !== 'undefined' &&
            ipCountry !== redirectArgs.site_code
        ) {
            return true;
        }
    }

    function noRedirectBox() {
        return navigator.userAgent.toLowerCase().indexOf('bot') > -1;
    }

    function createRedirectBox(ipCountry) {
        var navLinks = $('.nav-links');
        var localNav = $('.main_nav.local_nav');
        var redirectBox = $('.redirect-box');
        var oplistNav = $('#oplistNav');
        var oplistNavMobile = $('#oplistNavMobile');
        if (redirectBox) {
            $(navLinks).css({top: '113px'});
            $(localNav).css({top: '113px'});
            $(oplistNav).css({top: '268px'});
            $(oplistNavMobile).css({top: '262px'});
        }

        // append redirect message box on top
        $('.redirect-box').appendTo($('.container_redirect_message'));

        height = '95px'; // mobile
        if ($(window).width() >= 768) {
            height = '60px'; // medium and up
        }
        if ($(window).width() <= 420) {
            height = '115px'; // very small devices
        }

        $('.container_redirect_message').css({height: height}).slideDown(300);

        // add image flag
        // $('.redirect-box__main-message__flag').attr('src', clientLocationArgs.flag_url);

        // add main text
        $('.redirect-box__main-message__text').text(clientLocationArgs.main_message);

        // add sub text and link to leave button
        $('.redirect-box__action-leave')
            .text(clientLocationArgs.leave_button_text)
            .attr('href', clientLocationArgs.leave_button_href)
            .attr('data-gtm', 'geo_redirect ' + clientLocationArgs.leave_button_text);

        // set cookie on close button click
        $('.close-redirect-box').on('click', function () {
            setCookie('region_redirect_message', 1, 30);

            var redirectBox = $(this).parents('.redirect-box');
            $(redirectBox).css({position: 'relative'});

            var container = $(this).parents('.container_redirect_message');
            $(container).slideUp(300);
            $(navLinks).css({top: '54px'});
            $(localNav).css({top: '54px'});
            $(oplistNav).css({top: '108px'});
            $(oplistNavMobile).css({top: '102px'});
        });
    }

    init();
});
